import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

let singleRouter = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("./views/Home.vue"),
    },
    {
      path: "/product",
      name: "product",
      component: () => import("./views/Product.vue"),
    },
    {
      path: "/download",
      name: "download",
      component: () => import("./views/Download.vue"),
    },
    {
      path: "/downloadSbb",
      name: "downloadSbb",
      component: () => import("./views/DownloadSbb.vue"),
    },
    {
      path: "/downloadApp",
      name: "downloadApp",
      component: () => import("./views/DownloadApp.vue"),
    },
    {
      path: "/about",
      name: "about",
      component: () => import("./views/About.vue"),
    },
    {
      path: "/webview",
      name: "webview",
      meta: {
        outRoute: true,
      },
      component: () => import("./views/appWebview/index.vue"),
    },
    {
      path: "/iframeWeb",
      name: "iframeWeb",
      meta: {
        outRoute: true,
      },
      component: () => import("./views/appWebview/iframeWeb.vue"),
    },
    {
      path: "/document",
      name: "document",
      meta: {
        outRoute: true,
      },
      component: () => import("./views/document/index.vue"),
    },
    {
      path: "/dataSafeApi",
      name: "dataSafeApi",
      meta: {
        outRoute: true,
      },
      component: () => import("./views/lbSdk/dataSafeApi.vue"),
    },
    {
      path: "/dataSafeSdk",
      name: "dataSafeSdk",
      meta: {
        outRoute: true,
      },
      component: () => import("./views/lbSdk/dataSafeSdk.vue"),
    },
  ],
});

// 判断是否需要登录权限 以及是否登录
// singleRouter.beforeEach((to, from, next) => {
//   next();
//   // // 判断是否需要登录权限
//   // if (to.matched.some(res => res.meta.requireAuth)) {
//   //   // 判断是否登录
//   //   if (sessionStorage.getItem('token')) {
//   //     next()
//   //   } else {
//   //     // 没登录则跳转到登录界面
//   //     next({
//   //       path: '/login',
//   //       query: {
//   //         redirect: to.fullPath
//   //       }
//   //     })
//   //   }
//   // } else {
//   //   next()
//   // }
// });

export default singleRouter;
